import React from 'react';
import PropTypes from 'prop-types';

import { usePlayerProfile } from '../../common/hooks/use-player-profile';
import { getPositionNameByKey } from '../../stats-leaders/utils/positions';
import { getTranslation } from '../../../../../../../common/react/utils/translations';
import { OverviewTableCell } from './OverviewTableCell';
import { OverviewTableRow } from './OverviewTableRow';
import { OverviewTableDraftCell } from './OverviewTableDraftCell';
import { OverviewTableLinkCell } from './OverviewTableLinkCell';

export const OverviewTable = ({ seasonId, playerIds }) => {
    const playerOne = usePlayerProfile(seasonId, playerIds[1]);
    const playerTwo = usePlayerProfile(seasonId, playerIds[2]);

    return (
        <table className="overview-table">
            <tbody>
                <OverviewTableRow>
                    <OverviewTableCell
                        value={playerOne?.playerDetails?.position}
                        displayFunction={getPositionNameByKey}
                    />
                    <th scope="row" className="overview-table__header">
                        {getTranslation('label.statsCompare.position')}
                    </th>
                    <OverviewTableCell
                        value={playerTwo?.playerDetails?.position}
                        displayFunction={getPositionNameByKey}
                    />
                </OverviewTableRow>
                <OverviewTableRow>
                    <OverviewTableCell value={playerOne?.playerDetails?.age} />
                    <th scope="row" className="overview-table__header">
                        {getTranslation('label.statsCompare.age')}
                    </th>
                    <OverviewTableCell value={playerTwo?.playerDetails?.age} />
                </OverviewTableRow>
                <OverviewTableRow>
                    <OverviewTableCell
                        value={playerOne?.playerDetails?.heightCm}
                        suffix={'cm'}
                    />
                    <th scope="row" className="overview-table__header">
                        {getTranslation('label.statsCompare.height')}
                    </th>
                    <OverviewTableCell
                        value={playerTwo?.playerDetails?.heightCm}
                        suffix={'cm'}
                    />
                </OverviewTableRow>
                <OverviewTableRow>
                    <OverviewTableCell
                        value={playerOne?.playerDetails?.weightKg}
                        suffix={'kg'}
                    />
                    <th scope="row" className="overview-table__header">
                        {getTranslation('label.statsCompare.weight')}
                    </th>
                    <OverviewTableCell
                        value={playerTwo?.playerDetails?.weightKg}
                        suffix={'kg'}
                    />
                </OverviewTableRow>
                <OverviewTableRow>
                    <OverviewTableCell
                        value={playerOne?.careerTotals?.matchesPlayed}
                    />
                    <th scope="row" className="overview-table__header">
                        <span className="u-hide-until-tablet">
                            {getTranslation('label.statsCompare.totalGames')}
                        </span>
                        <span className="u-hide-from-tablet">
                            {getTranslation(
                                'label.statsCompare.totalGames.short'
                            )}
                        </span>
                    </th>
                    <OverviewTableCell
                        value={playerTwo?.careerTotals?.matchesPlayed}
                    />
                </OverviewTableRow>
                <OverviewTableRow>
                    <OverviewTableCell
                        value={playerOne?.playerDetails?.debutYear}
                    />
                    <th scope="row" className="overview-table__header">
                        {getTranslation('label.statsCompare.debut')}
                    </th>
                    <OverviewTableCell
                        value={playerTwo?.playerDetails?.debutYear}
                    />
                </OverviewTableRow>
                <OverviewTableRow>
                    <OverviewTableDraftCell player={playerOne} />
                    <th scope="row" className="overview-table__header">
                        {getTranslation('label.statsCompare.draft')}
                    </th>
                    <OverviewTableDraftCell player={playerTwo} />
                </OverviewTableRow>
                <OverviewTableRow>
                    <OverviewTableLinkCell player={playerOne} />
                    <th className="overview-table__header"></th>
                    <OverviewTableLinkCell player={playerTwo} />
                </OverviewTableRow>
            </tbody>
        </table>
    );
};

OverviewTable.propTypes = {
    seasonId: PropTypes.string.isRequired,
    playerIds: PropTypes.object.isRequired
};
